import backend, {AGENTCORE_ENGINE_API, AGENTCORE_ENGINE_WS_API} from 'utils/backend/server/api_library';
import {getJwtToken} from 'utils/auth/getSession';

class AgentChatWebsocketManager {
  constructor({onInit, onChunk, onUsage, onDone, onError, onClose} = {}) {
    this.ws = null;
    this.onInit = onInit;
    this.onChunk = onChunk;
    this.onUsage = onUsage;
    this.onDone = onDone;
    this.onError = onError;
    this.onClose = onClose;
  }

  async connect(message, sessionRn, newSessionOptions = {}) {
    const token = await getJwtToken();
    const url = `${AGENTCORE_ENGINE_WS_API}?token=${encodeURIComponent(token)}`;
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      const payload = {action: 'sendMessage', message, sessionRn: sessionRn || undefined};

      if (!sessionRn) {
        payload.agentTarget = newSessionOptions.agentTarget || undefined;
        payload.caseRn = newSessionOptions.caseRn || undefined;
      }

      this.ws.send(JSON.stringify(payload));
    };

    this.ws.onmessage = (evt) => {
      let data;
      try {
        data = JSON.parse(evt.data);
      } catch {
        return;
      }
      if (data.type === 'init') this.onInit?.(data);
      else if (data.type === 'chunk') this.onChunk?.(data);
      else if (data.type === 'usage') this.onUsage?.(data);
      else if (data.type === 'done') this.onDone?.(data);
      else if (data.type === 'error') this.onError?.(data);
    };

    this.ws.onerror = (event) => {
      console.error('WebSocket error:', event);
      this.onError?.({message: 'Connection error. Please try again.'});
    };

    this.ws.onclose = () => {
      this.onClose?.();
    };
  }

  close() {
    this.ws?.close();
  }
}

const sendMessage = (message, sessionRn) => {
  const url = `${AGENTCORE_ENGINE_API}/agent/chat`;
  return backend.post(url, {message, sessionRn});
};

const listSessions = () => {
  const url = `${AGENTCORE_ENGINE_API}/agent/chat/sessions`;
  return backend.get(url);
};

const getSession = (sessionRn) => {
  const url = `${AGENTCORE_ENGINE_API}/agent/chat/${sessionRn}`;
  return backend.get(url);
};

const stopSession = (sessionRn, runRn) => {
  const url = `${AGENTCORE_ENGINE_API}/agent/chat/${sessionRn}/stop`;
  return backend.post(url, {runRn});
};

export default {AgentChatWebsocketManager, sendMessage, listSessions, getSession, stopSession};
